import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Evet_horse } from '../models/evet/evet_horse';
import { Evet_vaccination } from '../models/evet/evet_vaccination';
import { Evet_document } from '../models/evet/evet_document';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class ElectronicVetService {

  constructor(private http: HttpClient) { }

  /*This results in a redireAct back to our account page
  	with the user id or an error message appended to our url string
  */
  doLinkUserToEvetId(email: string, password: string, type: string): Promise<any> {

    let post_data = {
          data: {
            type: 'evet_link_request',  attributes: {
                    'email': email,
                    'password': password,
                    'user_type': type
                }
             }
          };

          return new Promise((resolve, reject) => {
              return this.http.post(AppSettings.API_ENDPOINT + 'evet/link_user_id',
                  post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {

                       if(response.data && response.type=='evet_auth_response') {
                         resolve(response.data);
                         }  else {
                           reject(response);
                         }

                  }, error => {
                    if(error instanceof HttpErrorResponse){
                      reject(error.error);
                    } else {
                      reject(error);
                    }
                  });
            });


  }

  getEvetHorse(evet_id: string): Promise<Evet_horse> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'evet/evet_horse_lookup/evet_id/' + evet_id).subscribe((response:any) => {
      if(response.type == 'evet_horse' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

  getEvetHorseList(): Promise<Evet_horse[]> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'evet/evet_horse_list').subscribe((response:any) => {
      if(response.type == 'evet_horse_list' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

  getEvetHorseVaccinationList(horse_evet_id: string): Promise<Evet_vaccination[]> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'evet/evet_vaccination_list/evet_id/' + horse_evet_id).subscribe((response:any) => {
      if(response.type == 'evet_vaccination_list' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

  getEvetHorseDocumentList(horse_evet_id: string): Promise<Evet_document[]> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'evet/evet_document_list/evet_id/' + horse_evet_id).subscribe((response:any) => {
      if(response.type == 'evet_document_list' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

}
